// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import { registerControllers } from '@radioactive-labs/plutonium';
registerControllers(application);

import AdminDashboardController from './admin_dashboard_controller';
application.register('admin-dashboard', AdminDashboardController);

import ChartsController from './charts_controller';
application.register('charts', ChartsController);

import DropdownController from './dropdown_controller';
application.register('dropdown', DropdownController);

import FlashController from './flash_controller';
application.register('flash', FlashController);

import HelloController from './hello_controller';
application.register('hello', HelloController);

import IntlPhoneNumberInputController from './intl_phone_number_input_controller';
application.register('intl-phone-number-input', IntlPhoneNumberInputController);

import MobileMenuController from './mobile_menu_controller';
application.register('mobile-menu', MobileMenuController);

import ModalController from './modal_controller';
application.register('modal', ModalController);

import ShareController from './share_controller';
application.register('share', ShareController);

import ZakatCalculatorController from './zakat_calculator_controller';
application.register('zakat-calculator', ZakatCalculatorController);

import DashboardRefreshController from './dashboard_refresh_controller';
application.register('dashboard-refresh', DashboardRefreshController);

import ZakatModalController from './zakat_modal_controller';
application.register('zakat-modal', ZakatModalController);

import UserProfileController from './user_profile_controller';
application.register('user-profile', UserProfileController);
